import { PlanPricesType } from '../../plan-payment';

export const PLAN_PRICES_PER_CCU: PlanPricesType = {
  ko: {
    monthly: {
      basic: 7000,
      pro: 10000,
      saleRate: 0,
    },
    yearly: {
      basic: 5000,
      pro: 7000,
      saleRate: 0,
    },
    oneDay: {
      basic: 3500,
      pro: 5000,
      saleRate: 0,
    },
    threeDay: {
      basic: 5600,
      pro: 8000,
      saleRate: 0,
    },
    customMonth: {
      basic: 7000,
      pro: 10000,
      saleRate: 0,
    },
  },
  en: {
    monthly: {
      basic: 5.0,
      pro: 7.0,
      saleRate: 0,
    },
    yearly: {
      basic: 4.0,
      pro: 5.0,
      saleRate: 0,
    },
    oneDay: {
      basic: 2.5,
      pro: 3.5,
      saleRate: 0,
    },
    threeDay: {
      basic: 4.0,
      pro: 5.6,
      saleRate: 0,
    },
    customMonth: {
      basic: 5.0,
      pro: 7.0,
      saleRate: 0,
    },
  },
} as const;
